<div class="rp-mark" [style]="'--mark-color: ' + color()" [ngClass]="type()">
  @if (label() && !iconName()) {
    {{ label() }}
  }
  @if (iconName() && !label()) {
    <rp-icon class="icon" [iconName]="iconName()" size="s" />
  }
</div>
